<template>
    <div class="share-btn-wrapper">
        <div class="share-btn" :class="{ 'share-btn-active' : isOpened}" @click="openShare()">
            <transition name="slide-left">
              <div v-if="!isOpened">
                <a class="share-a-single"><span class="alcomet">F</span> Share</a>
              </div>
            </transition>
            <transition name="slide-right">
              <div class="share-btns-container" v-if="isOpened">
                <a class="share-a" @click.prevent="shareOnLinkedIn()"><span class="alcomet">C</span><span class="hide-on-mobile"> LinkedIn</span></a>
                <a class="share-a" @click.prevent="shareOnFacebook()"><span class="alcomet">D</span><span class="hide-on-mobile"> Facebook</span></a>
                <a class="share-a" @click.prevent="shareOnYoutube()"><span class="alcomet">E</span><span class="hide-on-mobile"> Youtube</span></a>
                <a class="share-a" @click.prevent="shareOnInstagram()"><span class="alcomet">B</span><span class="hide-on-mobile"> Instagram</span></a>
              </div>
            </transition>
            <transition name="slide-right">
              <div @click="closeShare($event)" class="share-btn-close" v-if="isOpened">
                <span class="alcomet">H</span>
              </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isOpened: false
    };
  },
  methods: {
    openShare() {
      this.isOpened = true;
    },
    shareOnLinkedIn() {
      this.isOpened = false;
    },
    shareOnFacebook() {
      this.isOpened = false;
    },
    shareOnYoutube() {
      this.isOpened = false;
    },
    shareOnInstagram() {
      this.isOpened = false;
    },
    closeShare(event) {
      event.stopPropagation();
      this.isOpened = false;
    }
  }
};
</script>

<style scoped>
.share-btn-wrapper {
  display: none;
  font-size: 19px;
  justify-content: flex-end;
  line-height: 32px;
  margin: 15px auto;
  width: 60%;
}
.share-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  margin: 30px 0;
  overflow: hidden;
  padding: 0 20px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 110px;
}
.share-btns-container {
  height: 100%;
  display: flex;
}
.share-btn > p {
  display: inline-flex;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  right: 0;
  top: 8px;
  width: initial;
}
.share-btn span {
  margin-right: 6px;
}
.share-btn:hover {
  background-color: #dde7ee;
}
.share-btn-active {
  width: 100%;
}
.share-btn-active:hover {
  background-color: transparent;
}
.share-a,
.share-a-single {
  align-items: center;
  display: inline-flex;
  height: 100%;
  position: relative;
  margin: 0 10px;
}
.share-a::before {
  background-color: #dde7ee;
  bottom: -0;
  content: "";
  height: 0;
  left: -10px;
  position: absolute;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: calc(100% + 20px);
  z-index: -1;
}
.share-a:hover::before {
  bottom: initial;
  height: 35px;
  top: 0;
}
.share-btn-close {
  align-items: center;
  border-left: 1px solid #588cc1;
  border-bottom-right-radius: 50%;
  border-top-right-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 29px;
  justify-content: center;
  padding: 7px;
  position: absolute;
  right: 2px;
  top: 2px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 29px;
}
.share-btn-close > span {
  font-size: 10px;
  margin: 0;
}
.share-btn-close:hover {
  border-color: #dde7ee;
  border-radius: 50%;
  background-color: #dde7ee;
}
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.2s;
  transition-delay: 0.2s;
}
.slide-left-leave-active,
.slide-right-leave-active {
  transition: all 0.1s;
}
.slide-left-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
@media screen and (max-width: 1000px) {
  .share-btn-wrapper {
    margin: 0;
    padding: 15px 30px;
    width: 100%;
  }
  .share-btn {
    margin: 0;
  }
}
@media screen and (max-width: 600px) {
  .hide-on-mobile {
    display: none;
  }
  .share-btn span {
    margin: 0;
  }
  .share-a-single span {
    margin-right: 6px;
  }
  .share-a span {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ShareButton.vue